import { createReducer, createSelector, on } from '@ngrx/store';
import {
    CreateFoyerCaseExport,
    GenerateProductSubscriptionReport,
    ReportActionFailure,
    ReportActionNoContent,
    ReportActionSuccess,
    ResetReportActionData
} from '../actions/reporting.actions';
import { AppState } from '../store';
import { ErrorResponse } from '../../shared/constants-and-enums/error-response';

export interface ReportingState {
    actionLoading: boolean;
    reportActionSuccess: boolean;
    reportActionNoContent: boolean;
    reportActionError: ErrorResponse;
}

export const initialState: ReportingState = {
    actionLoading: false,
    reportActionSuccess: false,
    reportActionNoContent: false,
    reportActionError: undefined
};

export const reportingReducer = createReducer(
    initialState,
    on(GenerateProductSubscriptionReport, CreateFoyerCaseExport, (state) => ({
        ...state,
        actionLoading: true,
        reportActionSuccess: false,
        reportActionError: undefined,
        reportActionNoContent: false
    })),
    on(ReportActionSuccess, (state) => ({
        ...state,
        actionLoading: false,
        reportActionSuccess: true,
        reportActionError: undefined,
        reportActionNoContent: false
    })),
    on(ReportActionFailure, (state, { error }) => ({
        ...state,
        actionLoading: false,
        reportActionSuccess: false,
        reportActionError: error,
        reportActionNoContent: false
    })),
    on(ReportActionNoContent, (state) => ({
        ...state,
        actionLoading: false,
        reportActionSuccess: true,
        reportActionError: undefined,
        reportActionNoContent: true
    })),
    on(ResetReportActionData, (state) => ({
        ...state,
        actionLoading: false,
        reportActionSuccess: false,
        reportActionError: undefined,
        reportActionNoContent: false
    }))
);

export const reportingState = (state: AppState) => state.reportingState;
export const reportingActionLoading = createSelector(reportingState, ({ actionLoading }) => actionLoading);
export const reportingActionSuccess = createSelector(reportingState, ({ reportActionSuccess }) => reportActionSuccess);
export const reportingActionError = createSelector(reportingState, ({ reportActionError }) => reportActionError);
export const reportingActionNoContent = createSelector(
    reportingState,
    ({ reportActionNoContent: reportingActionNoContent }) => reportingActionNoContent
);
